import { render } from "../views/header.html?vue&type=template&id=22024d6f&ts=true&external"
import script from "../scripts/header.ts?vue&type=script&lang=ts&external"
export * from "../scripts/header.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/header.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22024d6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22024d6f', __exports__)) {
    api.reload('22024d6f', __exports__)
  }
  
  module.hot.accept("../views/header.html?vue&type=template&id=22024d6f&ts=true&external", () => {
    api.rerender('22024d6f', render)
  })

}


export default __exports__